import React, { useEffect, useState } from 'react';
import { fetchBanner } from 'Shared/util/web-api';
import { Banner, BannerResource, BrandName, ErpIntegrationResource } from 'Shared/util/types';
import useBrandContext from 'Contexts/brand-context';
import Page from 'Shared/components/page/page';
import BusinessLoansBanner from 'Shared/components/banners/business-loans/business-loans-banner';
import AcconomyBanner from 'Shared/components/banners/acconomy/acconomy-banner';
import AcconomyReminderBanner from 'Shared/components/banners/acconomy/acconomy-reminder-banner';
import FortnoxBanner from 'Shared/components/banners/fortnox/fortnox-banner';
import FortnoxReminderBanner from 'Shared/components/banners/fortnox/fortnox-reminder-banner';
import InvoiceIntegrationSummaryNotice from './notices/invoice-integration-summary-notice';
import InvoiceManualNotice from './notices/invoice-manual-notice';
import PaymentSummaryNotice from './notices/payment-summary-notice';
import InvoiceSummarySection from './sections/invoice-summary-section';
import EventSection from './sections/event-section';
import DebtorSection from './sections/debtor-section';
import styles from './default-view.css';


const renderBanner = (banner?: BannerResource) => {
  if (!banner) return null;

  switch (banner.name) {
    case Banner.Acconomy:
      return <AcconomyBanner />;

    case Banner.BusinessLoans:
      return <BusinessLoansBanner />;

    case Banner.Fortnox:
      return <FortnoxBanner />;

    case Banner.UseIntegrationReminderAcconomy:
      return <AcconomyReminderBanner numberOfInvoices={banner.data?.numberOfInvoicesWithIncorrectOrigin || 0} />;

    case Banner.UseIntegrationReminderFortnox:
      return <FortnoxReminderBanner numberOfInvoices={banner.data?.numberOfInvoicesWithIncorrectOrigin || 0} />;

    default:
      return null;
  }
};

const renderSalesMethodNotice = (activeErpIntegration?: ErpIntegrationResource) => (
  activeErpIntegration
    ? <InvoiceIntegrationSummaryNotice erpIntegration={activeErpIntegration} />
    : <InvoiceManualNotice />
);

type DefaultViewProps = {
  activeErpIntegration?: ErpIntegrationResource;
};

const DefaultView = ({
  activeErpIntegration,
}: DefaultViewProps) => {
  const [banner, setBanner] = useState<BannerResource>();
  const { brandData, loadingBrandData } = useBrandContext();

  // NOTE (210511): This is not a long-term solution. Need to find a better way to support brand banners.
  useEffect(() => {
    if (loadingBrandData || brandData.name === BrandName.FinanceLink) return;

    /* NOTE: React might show an incorrect error ("Warning: Can't perform a React state update on an unmounted component...") if component
    have been unmounted on "setState". This should be fixed in upcoming release https://github.com/facebook/react/pull/22114 */
    fetchBanner()
      .then((result?: BannerResource) => setBanner(result));
  }, [loadingBrandData, brandData.name]);

  return (
    <div className={styles.container}>
      {renderBanner(banner)}
      <Page>
        <div className={styles.pageContainer}>
          <div className={styles.noticeSection}>
            {renderSalesMethodNotice(activeErpIntegration)}
            <PaymentSummaryNotice />
          </div>
          <InvoiceSummarySection />
          <EventSection />
          <DebtorSection />
        </div>
      </Page>
    </div>
  );
};

export default DefaultView;
